/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 道路上下
 */
export type IncidentRoadDirectionEnum =
  (typeof IncidentRoadDirectionEnum)[keyof typeof IncidentRoadDirectionEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IncidentRoadDirectionEnum = {
  UP: 'UP',
  DOWN: 'DOWN',
} as const;
